const FALLBACK_API_URI =
  "https://dashboard.bne.studio/api";

const trimTrailingSlash = (value) => value?.replace(/\/+$/, "");

const envApiBase = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || process.env.VITE_API_BASE_URL
);

export const remote_uri = envApiBase || FALLBACK_API_URI;
export const dev_remote_uri = remote_uri;
export const local_uri = "http://localhost:5500/api";
export const uri = remote_uri;
